import {Injectable} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material';

import {map, take} from 'rxjs/operators';
import {Observable} from 'rxjs/Observable';
import {CommonDialogNotificationComponent} from './common-dialog-notification.component';
import {DialogType} from './common.dialog.model';


@Injectable()
export class CommonDialogNotificationService {
  constructor(private dialog: MatDialog) {
  }

  public open(type: DialogType, message: string, dialogTitle: string = null, closeButtonText: string = null, timeout = null) {
    const data = {
      message: message,
      closeButtonText: closeButtonText,
      type: type,
      dialogTitle: dialogTitle
    };
    const dialogRef = this.dialog.open(CommonDialogNotificationComponent, {
      data: data,
      disableClose: true,
      panelClass: 'custom-dialog-container'
    });
    if (timeout != null) {
      dialogRef.afterOpen().subscribe(() => {
        setTimeout(() => {
          dialogRef.close();
        }, timeout);
      });
    }
    return dialogRef;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common-dialog-notification/common-dialog-notification.service.ts